<div class="dialogContainer">
  <div class="inputRow">
    <mat-form-field class="filterInput" [subscriptSizing]="'dynamic'">
      <mat-label>Filter</mat-label>
      <input #lineFilter matInput (keyup)="lines.filter = lineFilter.value"/>
    </mat-form-field>
    <span class="spacer"></span>
    <mat-paginator class="paginator" [pageSize]="20" [showFirstLastButtons]=true></mat-paginator>
  </div>
  <div class="tableWrapper">
    <table mat-table [dataSource]="lines" matSort class="paginatedTable bordered-table">
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox (change)="$event ? masterToggle() : null"
            [checked]="selection && selection.hasValue() && isAllSelected()"
            [indeterminate]="selection && selection.hasValue() && !isAllSelected()">
          </mat-checkbox>
        </th>
        <td class="centered-cell" mat-cell *matCellDef="let row">
          <mat-checkbox (click)="$event.stopPropagation()"
            (change)="$event ? toggleRowSelection(row) : null" [checked]="selection.isSelected(row)">
          </mat-checkbox>
        </td>
      </ng-container>
      <ng-container matColumnDef="lineId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="lineId">Line #</th>
        <td mat-cell *matCellDef="let line">{{ line.lineId }}</td>
      </ng-container>
      <ng-container matColumnDef="description">
        <th class="widerCell" mat-header-cell *matHeaderCellDef mat-sort-header="description">Description</th>
        <td class="widerCell" mat-cell *matCellDef="let line">{{ line.description }}</td>
      </ng-container>
      <ng-container matColumnDef="tag">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="tag">Tag</th>
        <td mat-cell *matCellDef="let line">{{ line.tags }}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr class="clickableRow" [class.selectedRow]="selection.isSelected(row)" mat-row
      *matRowDef="let row; columns: displayedColumns;" (click)="toggleRowSelection(row)"></tr>
    </table>
    @if (isBusy()) {
      <div class="busyIndicator">
        <div class="busyContents">
          <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
          <label class="busyLabel">Please Wait...</label>
        </div>
      </div>
    }
  </div>
  <div class="inputRow footer">
    <label class="outputLabel">Selected Line Count: {{ selectedQuantity() || 0 }}</label>
    <span class="spacer"></span>
    <button class="dialogButton warn-button" matButton="elevated" (click)="cancel()">Cancel</button>
    <button class="dialogButton primary-button" [disabled]="!isSelectionPresent()" matButton="elevated" (click)="save()">
      Select Lines
    </button>
  </div>
</div>
